{
  "nav": {
    "theSpace": "The Space",
    "schedule": "Schedule",
    "practices": "Practices",
    "masters": "Masters",
    "community": "Community",
    "fund": "Fund",
    "chats": "Chats",
    "myCalendar": "My Calendar",
    "feed": "Feed",
    "profile": "Profile",
    "messages": "Messages",
    "notifications": "Notifications",
    "discussion": "Discussion",
    "guestRoom": "Live Session Guest",
    "dashboard": "Dashboard",
    "studio": "Studio",
    "settings": "Settings",
    "aboutPlatform": "About the platform",
    "favorites": "Favorites",
    "calendar": "Calendar"
  },
  "menu": {
    "appearance": "Appearance",
    "language": "Language",
    "logout": "Log out",
    "login": "Log in",
    "masterBadge": "MASTER"
  },
  "pageTitle": {
    "download": "Get the app",
    "default": "Agapella — Knowledge, Practices and Live Events",
    "home": "The Space",
    "news": "News",
    "newsArticle": "Article",
    "landing": "24/7 Live Practices",
    "referralLanding": "Invitation",
    "login": "Log In",
    "register": "Sign Up",
    "confirmEmail": "Confirm Email",
    "forgotPassword": "Forgot Password",
    "resetPassword": "Reset Password",
    "dashboard": "Dashboard",
    "me": "My Profile",
    "masters": "Masters",
    "masterDetail": "Master Profile",
    "masterSubscriptions": "Subscriptions",
    "programPurchase": "Program purchase",
    "programPage": "Program",
    "agapeCenter": "Agapē Center",
    "lives": "Schedule",
    "eventsCalendar": "Calendar",
    "eventsAll": "All Events",
    "eventsFilters": "Filters",
    "eventDetail": "Event",
    "createEvent": "New Event",
    "eventParticipants": "Participants",
    "schedule": "Schedule",
    "upcoming": "Upcoming",
    "practices": "Practices",
    "practiceDetail": "Practice",
    "uploadPractice": "Upload Practice",
    "myCollection": "My Collection",
    "settings": "Settings",
    "liveDetail": "Live Session",
    "liveBroadcast": "Live Session",
    "chats": "Chats",
    "chatThread": "Chat",
    "community": "Community",
    "publicUserProfile": "Profile",
    "publicUserPost": "Post",
    "gamificationShare": "Light Path",
    "circleChat": "Circle",
    "about": "About",
    "aboutPlatform": "About the platform",
    "environment": "Environment",
    "gamificationPreview": "Gamification QA preview",
    "support": "Support",
    "contact": "Contact",
    "notificationSettings": "Notification Settings",
    "securitySettings": "Security",
    "blockedUsers": "Blocked Users",
    "myCalendar": "My Calendar",
    "myLibrary": "My Library",
    "memoryFacts": "What I remember about you",
    "fund": "Agápe Fund",
    "finance": "Finance",
    "financeDocuments": "My documents",
    "agapellaSubscription": "Agapēlla subscription",
    "fundDistribution": "Your Distribution",
    "howItWorks": "How It Works",
    "fundTransparency": "Fund Transparency",
    "referralCredits": "Referral Credits",
    "fundOnboarding": "Welcome to Agápe Fund",
    "masterWallet": "Wallet",
    "docs": "Documentation",
    "legalDoc": "Legal Document",
    "mission": "Agapella's Mission",
    "ethicsCode": "Agapella Code of Ethics",
    "custDev": "CustDev Dashboard",
    "soundLibrary": "Sound Library",
    "practiceRooms": "Live Sessions",
    "createLiveSession": "New Live Session",
    "liveSessionEntry": "Join Live Session",
    "liveRoomSession": "Live Session",
    "roomAnnouncement": "Session Details",
    "agapePractice": "The Agapē Practice",
    "eventThread": "Discussion",
    "feed": "Feed",
    "guestRoom": "Live Session Guest",
    "masterSales": "Sales",
    "masterAnalytics": "Analytics",
    "notifications": "Notifications",
    "payoutDetails": "Payout details"
  },
  "feed": {
    "empty": "Your feed is empty for now"
  },
  "favorites": {
    "filter": {
      "all": "All",
      "events": "Events",
      "practices": "Practices",
      "masters": "Masters",
      "myRooms": "My Live Sessions"
    },
    "empty": {
      "all": "Nothing in favorites yet. Tap the heart on any card to add it here.",
      "events": "No events in favorites. Tap the heart on an event card.",
      "practices": "No practices in favorites. Tap the heart on any practice.",
      "masters": "No subscriptions yet. Follow a master to see them here.",
      "myRooms": "Recordings of your live sessions will appear here after your first practice ends."
    },
    "unsave": "Remove from favorites"
  },
  "masterEvents": {
    "heading": "Master events",
    "filter": {
      "all": "All",
      "livestream": "Livestreams",
      "offline": "Offline",
      "livepractice": "Live practices"
    },
    "empty": {
      "all": "No upcoming events scheduled.",
      "livestream": "No upcoming livestreams.",
      "offline": "No upcoming offline gatherings.",
      "livepractice": "No open live sessions."
    }
  },
  "state": {
    "loading": "Loading…",
    "error": "Something went wrong",
    "empty": "Nothing here yet",
    "retry": "Try again"
  },
  "buttons": {
    "logIn": "Log In",
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "logOut": "Log Out",
    "joinPractice": "JOIN PRACTICE",
    "joinLiveNow": "JOIN LIVE NOW",
    "classSchedule": "CLASS SCHEDULE",
    "viewAll": "VIEW ALL",
    "retry": "RETRY",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "SAVE",
    "back": "BACK",
    "next": "NEXT",
    "finish": "FINISH",
    "accept": "Accept",
    "decline": "Decline",
    "notNow": "Not now",
    "explore": "Explore",
    "sendMessage": "SEND MESSAGE",
    "message": "MESSAGE",
    "sending": "SENDING...",
    "hide": "Hide",
    "goBack": "GO BACK",
    "tryAgain": "TRY AGAIN",
    "browseLibrary": "BROWSE LIBRARY",
    "explorePractices": "EXPLORE PRACTICES",
    "exploreSchedule": "EXPLORE SCHEDULE",
    "create": "Create",
    "createA11y": "Create",
    "quickRoom": "Quick Room",
    "quickRoomShort": "Quick",
    "quickRoomA11y": "Create Quick Room",
    "liveSession": "Live session",
    "liveSessionShort": "Live",
    "liveSessionA11y": "Create a Live session",
    "myCalendarUpper": "MY CALENDAR",
    "linkCopied": "Link copied",
    "done": "Done",
    "showMore": "More",
    "showLess": "Show less"
  },
  "theme": {
    "mode": "{{mode}} mode"
  },
  "footer": {
    "tagline1": "Masters, live sessions, communities, events – 24/7",
    "tagline2": "A platform for those who choose to be human in practice",
    "platform": "Platform",
    "company": "Company",
    "legal": "Legal",
    "about": "About",
    "contact": "Contact",
    "careers": "Careers",
    "termsOfUse": "Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "aiNotice": "AI notice",
    "cookieSettings": "Cookie settings",
    "streamingAgreement": "Practitioner Agreement",
    "deleteAccount": "Delete account",
    "mission": "Mission",
    "ethicsCode": "Code of Ethics",
    "referral": "Referral programme",
    "copyright": "© 2026 Agapella. All rights reserved.",
    "legalEntity": "In Russia, the service is provided by JSC «Tsifrovaya II Transformatsiya» (АО «Цифровая ИИ Трансформация») · INN 9729424798 · KPP 772901001 · OGRN 1267700307841 · 10 Bogdanova St., bldg. 2, prem. 2/3, Moscow, 119618, Russia",
    "legalEntityIntl": "The service is provided by AGAPE.IO Limited · Room 1803, 18/F, Lucky Centre, No. 165–171 Wan Chai Road, Wan Chai, Hong Kong",
    "designedFor": "Designed for growth."
  },
  "cookies": {
    "title": "Cookies and counters",
    "description": "Cookies keep sign-in, your settings and basic visit statistics working. Other analytics and marketing counters are loaded only with your consent, and you can choose by category.",
    "policyLink": "Privacy Policy, section 15",
    "acceptAll": "Accept",
    "necessaryOnly": "Keep necessary only",
    "decline": "Decline",
    "customize": "Customize",
    "settingsTitle": "Cookie settings",
    "settingsIntro": "Choose which cookies and counters may be used. You can change this at any time: the “Cookie settings” link is at the bottom of the page and in your profile settings.",
    "alwaysOn": "Always on",
    "necessary": {
      "title": "Necessary",
      "description": "Sign-in, security, keeping your session and basic visit statistics that show us how the platform works."
    },
    "functional": {
      "title": "Functional",
      "description": "Your settings on this device: theme, language, volume, dismissed hints. They are not shared with third parties."
    },
    "analytics": {
      "title": "Analytics",
      "description": "Additional third-party traffic counters. They show which pages people open and what is worth improving."
    },
    "marketing": {
      "title": "Marketing",
      "description": "Counters of advertising services. They show which ads bring people to the platform."
    },
    "providers": {
      "metrika": "Yandex Metrica",
      "ga4": "Google Analytics",
      "vk": "VK pixel"
    },
    "providersList": "Loaded: {{list}}",
    "providersNone": "There are no counters in this category right now.",
    "reloadHint": "A counter you turn off stops working after the page is reloaded.",
    "save": "Save choice",
    "close": "Close"
  },
  "authCta": {
    "onboarding": {
      "heading": "Save your preferences",
      "body": "Sign up to save your preferences and get personalized session recommendations."
    },
    "gatedAction": {
      "heading": "Access Agapella Features",
      "body": "Please log in or register to continue."
    }
  },
  "time": {
    "now": "now",
    "justNow": "just now",
    "minsAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago",
    "min": "MIN",
    "minutes": "min",
    "hourShort": "h"
  },
  "calendar": {
    "button": "CALENDAR",
    "google": "Google Calendar",
    "downloadIcs": "Download .ics",
    "addToCal": "Add to Cal",
    "downloadFailed": "Could not download calendar file. Please try again.",
    "googleFailed": "Could not open Google Calendar. Please try again."
  },
  "errors": {
    "title": "Error",
    "generic": "Something went wrong. Please try again.",
    "failedToPost": "Failed to create post",
    "notFound": "Not found"
  },
  "events": {
    "liveNow": "LIVE",
    "live": "LIVE",
    "upcoming": "UPCOMING",
    "notifyMe": "NOTIFY ME",
    "notified": "NOTIFIED",
    "registered": "REGISTERED",
    "register": "REGISTER",
    "subscribed": "SUBSCRIBED",
    "online": "Live Stream",
    "onlineEvent": "Live Stream",
    "locationTba": "TBA",
    "locationTbaFull": "Location TBA",
    "spotsAvailable": "{{left}} / {{total}} spots left",
    "unlimitedSpots": "Unlimited spots",
    "percentFilled": "% filled",
    "aboutThisEvent": "ABOUT THIS EVENT",
    "contact": "CONTACT",
    "featured": "FEATURED"
  },
  "eventContact": {
    "title": "Contact Organizer",
    "aboutPrefix": "About: {{title}}",
    "messageSent": "Message sent",
    "messageDelivered": "Your message has been delivered. They will respond shortly.",
    "nameLabel": "YOUR NAME",
    "namePlaceholder": "Enter your name",
    "emailLabel": "EMAIL (OPTIONAL)",
    "emailPlaceholder": "your@email.com",
    "messageLabel": "MESSAGE",
    "messagePlaceholder": "Your message...",
    "emailFallback": "Or email directly: {{email}}",
    "validationError": "Please fill in your name and message",
    "sendFailed": "Failed to send message. Please try again."
  },
  "chat": {
    "folder": {
      "ai": "AI",
      "circles": "Circles",
      "friends": "People"
    },
    "sidebar": {
      "searchPlaceholder": "Search",
      "empty": "Nothing here yet. Chats will appear as they happen."
    },
    "header": {
      "aiTyping": "typing",
      "typing": "typing…",
      "aiSubtitle": "AI friend",
      "members": "{{count}} members",
      "online": "online"
    },
    "aboutEvent": "About this Event",
    "liveSession": "Live Session",
    "byMaster": "By {{name}}",
    "defaultDescription": "Join {{name}} for a transformative live practice...",
    "reconnecting": "Reconnecting...",
    "disconnected": "Chat disconnected",
    "firstMessage": "Be the first to share your thoughts...",
    "sayHello": "Say hello to the community",
    "host": "HOST",
    "offering": "MAKE AN OFFERING",
    "thankYou": "Thank you for your offering of ${{amount}} 🙏",
    "customAmount": "Custom Amount",
    "placeholder": "Write to the practice chat…",
    "archiveNotice": "The live session was cancelled. Chat is closed.",
    "endedNotice": "The live session has ended. The chat is saved here, and the conversation continues in the discussion.",
    "replyInDiscussion": "Reply in the discussion",
    "continueInDiscussion": "Continue in the discussion",
    "openMasterProfile": "Open the master's profile",
    "time": {
      "now": "just now",
      "minutesAgo": "{{count}} min ago"
    }
  },
  "profile": "PROFILE",
  "contact": {
    "title": "WE ARE IN TOUCH",
    "subtitle": "We are glad to talk and hear your feedback. Write to us!",
    "email": "Email",
    "instagram": "Instagram",
    "youtube": "YouTube",
    "teamTitle": "Agape to all!",
    "teamText": "Hello! We are the distributed team of the Agapella platform, working from different countries, in different time zones, beyond geography. If you have questions, difficulties using the platform, or you have noticed an error or any violation of the platform's rules or code of ethics by a master or other users, please write to us about it! If your experience with the platform, masters or communities left warm impressions and added a sense of support and love, please share your emotions and observations. Together with you and thanks to your feedback we develop the platform."
  },
  "kula": {
    "globalCommunity": "GLOBAL COMMUNITY",
    "circleTitle": "Circle",
    "circleSub": "Find practitioners. Join circles. Walk the path together.",
    "searchCircles": "Search circles...",
    "circlesSection": "Circles",
    "peopleSection": "People",
    "open": "OPEN",
    "join": "JOIN",
    "members": "MEMBERS",
    "allCategories": "All",
    "create": "Create",
    "noCircles": "No circles found. Try another category or search.",
    "noCirclesFound": "No circles found",
    "noMembersFound": "No members found",
    "heroPhase1Title": "Design your environment.",
    "heroPhase1Scroll": "EXPLORE",
    "heroPhase2Title": "Find your people",
    "heroPhase2Sub": "Join circles based on philosophy and interests. Grow, practice, and evolve together with like-minded souls.",
    "categories": {
      "meditation": "Meditation",
      "psychology": "Psychology",
      "philosophy": "Philosophy",
      "denominations": "Denominations",
      "body_practices": "Body Practices",
      "spiritual_practices": "Spiritual Practices",
      "morning_evening": "Morning & Evening",
      "leadership": "Leadership",
      "motivation": "Motivation"
    }
  },
  "room": {
    "share": {
      "subject": "Join the «{{title}}» live session on Agapella",
      "message": "Join the «{{title}}» live session on Agapella\n{{url}}",
      "untitled": "Live session",
      "toFeed": "To my feed",
      "toFeedHint": "The announcement of this live session will appear in your feed",
      "toFeedNoAnnouncement": "This live session has no announcement in the feed, so it cannot be reposted yet",
      "toFeedLookupFailed": "Could not check whether the feed has an announcement. Close the menu and open it again",
      "practiceToFeed": "Share the practice to my feed",
      "practiceToFeedHint": "Library practice: «{{title}}»",
      "inApp": "In Agapella"
    },
    "reflection": {
      "banner": "Reflection · {{time}} remaining"
    },
    "completed": {
      "banner": "Practice complete · the live session stays open"
    },
    "countdown": {
      "banner_one": "Starting in {{count}}s — prepare your space",
      "banner_other": "Starting in {{count}}s — prepare your space"
    },
    "tile": {
      "cameraOff": "Camera off",
      "videoOnStage": "Video on stage",
      "nowPlaying": "Now playing",
      "videoPractice": "Video practice",
      "host": "host",
      "micLive": "Microphone on: {{name}}",
      "micMuted": "Microphone off: {{name}}",
      "mutedByHost": "Muted by the host: {{name}}",
      "handRaised": "Hand raised: {{name}}"
    },
    "stage": {
      "moreAhead": "+{{count}} · swipe"
    },
    "meta": {
      "by": "by {{name}}",
      "rec": "REC",
      "raised": "{{count}} raised"
    },
    "roster": {
      "cohost": "Host"
    },
    "participant": {
      "joined": "Joined {{time}}",
      "handRaised": "Hand raised",
      "close": "Close",
      "roleHost": "Host",
      "roleParticipant": "Participant",
      "micOff": "Muted",
      "micOn": "Speaking",
      "videoOn": "Video on",
      "audioOnly": "Audio only"
    },
    "archive": {
      "chatTitle": "Chat",
      "readOnly": "read-only"
    },
    "panel": {
      "chat": "Chat",
      "participants": "Participants · {{count}}"
    },
    "ended": {
      "banner": "Session complete"
    },
    "silent": {
      "banner": "Silent practice — the host hasn't allowed turning on the mic and camera",
      "micDisabled": "Mic is off: a silent practice is in progress",
      "camDisabled": "Camera is off: a silent practice is in progress",
      "camBlockedByHost": "The host has turned participant cameras off",
      "micBlockedByHost": "The host has disabled participant microphones",
      "camBlockedForYou": "The host turned your camera off"
    },
    "locked": {
      "micStageFull": "All speaker spots are taken right now",
      "camStageFull": "All speaker spots are taken right now",
      "micUnavailable": "The mic is unavailable right now",
      "camUnavailable": "The camera is unavailable right now"
    },
    "seat": {
      "devicesNotAllowed": "The host has not allowed microphones or cameras",
      "stageFull": "All speaker spots are taken right now. Try turning on again when a spot frees up",
      "unavailable": "Couldn't turn on right now. Please try again a bit later",
      "network": "Couldn't turn on: no connection to the server. Please try again"
    },
    "floorGranted": {
      "micHint": "The host gave you the floor. Turn on your microphone to be heard"
    },
    "spectator": {
      "watchingAsGuest": "You're watching as a guest",
      "joinedAs": "Joined as {{name}}",
      "signIn": "Sign in",
      "signInToParticipate": "Sign in to participate",
      "signInToSpeakChat": "Sign in to speak and chat",
      "signInToChat": "Sign in to write in chat",
      "signInToRaiseHand": "Sign in to raise your hand",
      "publishDenied": "The floor is yours, but the microphone has not opened yet. Reload the page or ask the host to grant the floor again",
      "viewersWithoutAccount": "Watching without an account: {{count}}",
      "moreViewers": "and {{count}} more who arrived before you",
      "sectionTitle": "LISTENERS",
      "roleLabel": "Listener"
    },
    "chat": {
      "placeholder": "Type a message…",
      "connecting": "Chat is connecting…",
      "freeze": "Turn chat off",
      "unfreeze": "Turn chat on",
      "frozenPlaceholder": "The host turned the chat off",
      "mutedPlaceholder": "The host has limited your messages in this chat",
      "mutedUntilPlaceholder": "The host has limited your messages in this chat until {{time}}",
      "emoji": "Emoji",
      "pinnedTitle": "Pinned message",
      "unpin": "Unpin",
      "pinFailed": "Could not change the pinned message. Please try again.",
      "deleteConfirmTitle": "Delete this message?",
      "deleteConfirmBody": "It will disappear for everyone in the live session. This cannot be undone.",
      "deleteConfirm": "Delete",
      "deleteFailed": "Could not delete the message. Please try again.",
      "attach": {
        "attach": "Attach a file",
        "uploading": "Uploading…",
        "retry": "Try again",
        "remove": "Remove {{name}}",
        "lessThanMb": "under 1 MB",
        "mb": "{{n}} MB",
        "defaultName": "file",
        "defaultImage": "Image",
        "defaultFile": "Document",
        "andMore": "{{list}} and more",
        "unsupported": "This file can't be sent. Images ({{images}}) and documents ({{docs}}) work.",
        "imageTooLarge": "Images can be up to {{limit}}; this one is {{size}}. Choose a smaller file or compress this one.",
        "fileTooLarge": "Documents can be up to {{limit}}; this one is {{size}}. Choose a smaller file.",
        "tooMany": "A message holds up to {{max}} files. Send these and continue in the next one.",
        "uploadFailed": "The file didn't upload. Please try again.",
        "sendFailed": "The message wasn't sent. Please try sending it again.",
        "refusedForbidden": "You can't attach files here right now.",
        "refusedInvalid": "This file was already sent or has expired. Remove it and attach it again.",
        "refusedFrozen": "The host turned off the chat, so the message was not sent.",
        "refusedMuted": "The host has temporarily limited your messages in this chat, so the message was not sent.",
        "unavailable": "{{name}} is no longer available",
        "openImage": "Open image: {{name}}",
        "downloadFile": "Download document: {{name}}",
        "kb": "{{n}} KB",
        "progress": "{{loaded}} of {{total}}",
        "statusUploading": "Uploading {{count}} of {{total}}",
        "statusQueued": "the message will go once everything is uploaded",
        "queueFailed": "Not everything uploaded — retry or remove the file that failed",
        "queueRejected": "Remove the file that wasn't accepted first — then the message will go.",
        "failedShort": "Didn't upload",
        "retryShort": "Retry",
        "downloadAll": "Download all · {{size}}",
        "unavailableShort": "File is no longer available",
        "serverUnsupported": "This file format isn't supported.",
        "serverTooLarge": "The file is too large.",
        "replaceHint": "Remove it and choose another file.",
        "failureLine": "{{name}} — {{reason}}",
        "failedIcon": "File not accepted: {{reason}}"
      }
    },
    "system": {
      "welcome": "Welcome to the live session",
      "guestWelcome": "Hi, I'm glad you're here at Agapella. You're watching this live session as a guest — sign in or sign up to write in the chat and raise your hand. It won't be interrupted.",
      "practiceBegins": "🙏 Practice begins now",
      "sessionBegins": "🙏 The live session begins now",
      "practiceComplete": "🧘 Practice complete. Entering reflection period...",
      "practiceCompleteStay": "🧘 Practice complete. The live session stays open — chat on or pick another practice.",
      "sessionComplete": "✨ Session complete. Thank you for practicing together.",
      "plannedTimeElapsed": "⏳ The planned time is up. The live session stays open — end it by hand or keep talking.",
      "chatConnecting": "Chat is connecting — try again in a moment.",
      "chatSendFailed": "Your message wasn't sent — the connection dropped. The text is back in the input.",
      "chatRateLimited": "Your message wasn't sent — too many in a row. Wait a couple of seconds and send it again.",
      "chatMuted": "The host has temporarily limited your messages in this chat. It wasn't sent; the text stays in the input field.",
      "nowPlaying": "🎵 Now playing: {{title}}",
      "spectating": "Watching as {{name}}",
      "handRaiseFailed": "Couldn't raise your hand — the connection dropped. Please try again.",
      "handLowerFailed": "Couldn't lower your hand — the connection dropped. Please try again."
    },
    "leave": {
      "titleHost": "End Practice",
      "titleGuest": "Leave Live Session",
      "bodyHost": "End the practice and close the live session for everyone? This cannot be undone.",
      "bodyGuest": "Leave the live session? The practice keeps going — other participants stay. You can rejoin via the link.",
      "stay": "Stay",
      "end": "End",
      "leave": "Leave",
      "navGuard": "You are leaving while a practice is running. The live session will keep going — guests will stay in it. Leave?",
      "navGuardWaiting": "The live session has not started yet — you are leaving the waiting hall. It stays open and guests will wait for the start. Leave?",
      "handover": {
        "title": "You are leaving the session",
        "body": "The session can keep going if you hand control to someone who is here. Or you can end it for everyone.",
        "bodyEmpty": "There is no one to hand control to — you are alone in the session. You can stay, or end it for everyone.",
        "handOver": "Hand over and leave",
        "endForAll": "End the session for everyone",
        "stay": "Stay in the session",
        "pickTitle": "Who takes over",
        "pickBody": "Choose who will keep hosting. They get an offer to become a host, and you leave once they accept. You remain the author — the announcement and the recordings stay yours.",
        "confirm": "Offer and leave",
        "handingOver": "Sending…",
        "pickBodyHost": "This person is already a host — no invitation needed. You leave right away and the Live session goes on. You remain the author: the announcement and recordings stay yours.",
        "confirmHost": "Hand over and leave",
        "leavingWithHost": "Leaving…",
        "back": "Back",
        "someone": "Participant",
        "errorGone": "That participant has already left. Pick someone else.",
        "errorNotHere": "That participant is not in the session. Refresh the list and pick someone else.",
        "errorFailed": "Could not hand over control. You are still the host — try again.",
        "bodyNotAllowed": "Control of this session can't be handed over: extra hosts are available only in a master's sessions. You can stay, or end it for everyone.",
        "errorNotAllowed": "Control of this session can't be handed over: extra hosts are available only in a master's sessions. You can stay, or end it for everyone.",
        "bodyWithHosts": "Other hosts stay in the session — it will continue without you. Or you can end it for everyone.",
        "leaveOnly": "Leave — the other hosts carry on",
        "waitingTitle": "Waiting for an answer",
        "waiting": "{{name}} has been offered the host role. You will leave as soon as they accept.",
        "cancelWait": "Cancel and stay",
        "errorDeclined": "{{name}} declined. Pick someone else or end the session.",
        "errorExpired": "The offer to {{name}} is no longer valid. Pick again."
      },
      "failedTitle": "Couldn't leave",
      "failedBody": "The connection to the server dropped and your leave wasn't saved. You're still in the Live session — please try leaving again."
    },
    "status": {
      "connecting": "Connecting to the live session…",
      "rateLimited": "Too many requests — trying again…",
      "unavailable": "Live Session Not Available",
      "notFound": "Live session not found or has ended",
      "removed": "You were removed from this live session",
      "goHome": "Go Home",
      "linkCopied": "Live session link copied to clipboard",
      "linkTitle": "Live Session Link",
      "inviteTitle": "Invite Link"
    },
    "actions": {
      "end": "END",
      "leave": "LEAVE",
      "stepOut": "STEP OUT",
      "mediaError": "Failed to switch media",
      "mediaAudioLocked": "Background music isn’t available in this Live session. You can pick a library practice on the Video tab.",
      "mediaAudioNotAllowed": "Background music isn’t available in this Live session.",
      "mediaNoRights": "You don’t have permission to change media in this Live session.",
      "mediaPracticeUnavailable": "This practice can’t be shown in a Live session.",
      "error": "Error"
    },
    "kicked": {
      "title": "Removed",
      "body": "You have been removed from this live session by the host."
    },
    "defaultTitle": "Live Session",
    "createFailed": "Couldn't create the live session",
    "tryAgain": "Please try again.",
    "sessionMoved": {
      "title": "Session moved",
      "body": "You joined this live session from another device. This session has been moved.",
      "close": "OK, close",
      "rejoin": "Rejoin here"
    },
    "kickParticipant": {
      "title": "Remove Participant",
      "message": "Remove {{name}} from the live session?",
      "confirm": "Remove",
      "cancel": "Cancel",
      "button": "Remove"
    },
    "returnHint": {
      "titleScheduled": "The live session is scheduled",
      "bodyScheduled": "You can step out onto the platform and come back to this live session later from the “Upcoming event” block on your profile.",
      "titleReady": "The live session is ready",
      "bodyReady": "You can step out and come back to it from your profile before the live session starts.",
      "dismiss": "Got it",
      "close": "Close"
    },
    "allowParticipantCamera": "Allow camera",
    "webRtcUnsupported": {
      "text": "This browser doesn't support sound and video in a Live session. Open the link in Safari or Chrome, and if Lockdown Mode is on on your iPhone, turn it off for this site."
    },
    "poorLink": {
      "text": "The connection is unsteady right now, so sound may lag. If you're using a VPN, try without it — it usually sounds clearer.",
      "dismiss": "Dismiss"
    },
    "screenAwake": {
      "textIos": "Your screen may turn off during the live session. Increase the Auto-Lock time: Settings → Display & Brightness → Auto-Lock.",
      "textIosTap": "To keep your screen on during the live session, tap it.",
      "textAndroid": "Your screen may turn off during the live session. Increase the screen timeout: Settings → Display → Screen timeout.",
      "dismiss": "Dismiss"
    },
    "hosts": {
      "inviteTitle": "Become a host?",
      "inviteBody": "{{name}} invites you to host this live session. All hosts have the same tools: practice, background audio, participants, chat, screen, recording and ending the session.",
      "accept": "Accept",
      "decline": "Decline",
      "accepting": "Accepting…",
      "declining": "Declining…",
      "becameHost": "{{name}} is now a host",
      "noLongerHost": "{{name}} is no longer a host",
      "youAreHost": "You are now a host",
      "youAreNoLongerHost": "You are no longer a host",
      "invited": "{{name}} has been offered the host role",
      "declined": "{{name}} declined to host",
      "someone": "Participant",
      "errors": {
        "registration_required": "Only a participant with an account can become a host. A guest needs to sign in or sign up.",
        "already_host": "This participant is already a host.",
        "not_present": "The participant has already left the session.",
        "not_pending": "The offer is no longer valid.",
        "stage_full": "There are no free places on stage — take the floor from someone first.",
        "session_ended": "The live session has already ended.",
        "not_allowed": "Hosts can't be added in this session — that's available in a master's sessions.",
        "failed": "Something went wrong. Please try again."
      }
    }
  },
  "security": {
    "title": "Sign-in security",
    "subtitle": "Add a passkey to sign in without a password — fingerprint, face, or device key.",
    "addPasskey": "Add passkey",
    "connectedDevices": "CONNECTED DEVICES",
    "empty": "No passkeys yet. Add one and you won't need a password again.",
    "unsupportedBrowser": "This browser doesn't support passkeys. Open Agapella in a recent Chrome, Safari, or Firefox.",
    "unsupportedNative": "Passkeys are web-only for now. Open agapella.io in a browser to set one up.",
    "unavailableOnServer": "Passkeys aren't enabled on this server yet. Check back shortly.",
    "loading": "Loading…",
    "device": "Device",
    "added": "added ",
    "lastUsed": "last used: ",
    "password": {
      "sectionTitle": "PASSWORD",
      "setTitle": "Set a password",
      "setSubtitle": "You currently sign in with Google or Apple. Set a password so you can also sign in with your email.",
      "changeTitle": "Change password",
      "changeSubtitle": "We'll email a link to {{email}} so you can set a new one.",
      "sendButton": "Email me a link",
      "sending": "Sending…",
      "sentTitle": "Check your inbox",
      "sentBody": "We sent a link to {{email}}. Open it to set your password — it stays valid for an hour.",
      "error": "Couldn't send the link. Please try again in a moment."
    },
    "mcp": {
      "sectionTitle": "Access for AI clients",
      "title": "Your sessions in Claude and other AI clients",
      "subtitle": "A key lets an AI client read your sessions: the list, recording transcripts and chat — exactly what you see here. Read-only. You can revoke a key at any time.",
      "mint": "Create key",
      "minting": "Creating…",
      "empty": "No keys yet.",
      "keyDefaultLabel": "Key",
      "created": "Created ",
      "lastUsed": "used ",
      "never": "never",
      "revoked": "revoked",
      "show": "Show",
      "hide": "Hide",
      "copy": "Copy",
      "copied": "Copied",
      "revoke": "Revoke",
      "revokeConfirm": "Revoke key {{key}}? An AI client using it loses access within a minute.",
      "configTitle": "Connection",
      "configHint": "Add this to your MCP client settings (Claude Code, Claude Desktop):",
      "unavailable": "Creating keys is not available on the server right now.",
      "error": "Something went wrong. Please try again."
    }
  },
  "aboutPlatform": {
    "title": "About Agapella",
    "subtitle": "Agapella is a platform for mental health, psychological well-being and inner growth, for living interaction between masters and kindred-spirited participants.",
    "tabs": {
      "participants": "For participants",
      "masters": "For masters"
    },
    "showMore": "Show all",
    "showLess": "Show less",
    "missionCta": "More about the platform's mission",
    "banner": {
      "title": "Agapella — a space of shared action and participation",
      "text": "Agapella is «we»: students and masters of different schools and traditions come together to create a mindful, supportive community."
    },
    "error": "Couldn't load the page. Please try again later.",
    "retry": "Retry"
  },
  "referral": {
    "title": "Referral programme",
    "lead": "Share your Agapella link. When the people you bring buy courses and programmes from masters, part of the amount comes back to you — in real money.",
    "leadPoints": "Share your Agapella link with people it will speak to. Invitations may earn points: they give a discount inside Agapella and cannot be exchanged for money.",
    "pointsNote": "The rules for earning points will appear here once they are approved. The terms are in the Terms of Use.",
    "yourLink": "Your link",
    "copyLink": "Copy link",
    "clicks": "Clicks",
    "registrations": "Sign-ups",
    "buyers": "Buyers",
    "earned": "Earned",
    "available": "Available for payout",
    "paid": "Paid out",
    "join": "Join the programme",
    "enrolling": "Joining",
    "enrollFailed": "Could not join the programme. Please try again.",
    "termsAccept": "I accept the referral programme terms",
    "termsRead": "Read the terms",
    "termsHide": "Hide the terms",
    "termsLoadFailed": "Could not load the text. Please try opening it again.",
    "termsUnavailable": "The programme terms are still being prepared. You will be able to join once they are published.",
    "termsReacceptTitle": "Referral programme terms",
    "termsReacceptLead": "To receive payouts, please accept the current version of the terms. Rewards from your link keep accruing in the meantime.",
    "termsReacceptCta": "Accept the terms",
    "termsReacceptSaving": "Saving…",
    "recentAccruals": "Recent earnings",
    "level1": "First level",
    "level2": "Second level",
    "statePending": "Available later",
    "statePendingUntil": "Available on",
    "stateAvailable": "Available for payout",
    "statePaid": "Paid out",
    "stateReturned": "Returned",
    "stateOnReview": "Under review",
    "nextPayout": "Next payout —",
    "payoutsPaused": "Payouts aren't available yet. Your rewards keep adding up and won't go anywhere — we'll let you know when you can withdraw them.",
    "payoutDetails": {
      "entry": "Payout details",
      "entryEmpty": "not filled in",
      "entryFilled": "filled in",
      "title": "Payout details",
      "lead": "Rouble payouts need your tax details and a bank account. They go to a server in Russia and stay there — this screen sends them directly, bypassing the rest of the platform.",
      "unavailable": "Payout details aren't being collected yet. We'll let you know when they are.",
      "fieldInn": "Tax number (INN)",
      "fieldBank": "Bank details",
      "filledPlaceholder": "filled in — type again to change",
      "inn": "Tax number (INN)",
      "beneficiaryName": "Account holder's full name",
      "bankAccount": "Account number",
      "bankBic": "Bank BIC",
      "bankName": "Bank name",
      "taxStatus": "Tax status",
      "taxStatuses": {
        "individual": "Individual",
        "self_employed": "Self-employed",
        "sole_trader": "Sole trader"
      },
      "consentText": "I consent to the processing of my personal data for payouts and the related tax obligations. Consent can be withdrawn at any time.",
      "save": "Save",
      "saving": "Saving…",
      "saved": "Saved.",
      "revoke": "Withdraw consent",
      "erase": "Delete my data",
      "revokedNote": "Consent withdrawn, details erased. Rouble payouts are paused.",
      "rightsNote": "Withdrawing consent stops payouts and erases the details. Your earnings history stays — it's needed for accounting.",
      "errors": {
        "INVALID_INN": "That tax number fails its checksum. Please check the digits.",
        "INVALID_SNILS": "That insurance number fails its checksum. Please check the digits.",
        "INVALID_BIC": "A BIC is nine digits.",
        "INVALID_ACCOUNT": "The account number and BIC don't match. Please check both.",
        "INVALID_TAX_STATUS": "Choose a tax status.",
        "CONSENT_REQUIRED": "We can't save this without your consent to data processing.",
        "INN_ALREADY_USED": "That tax number is already linked to another account.",
        "TAX_CONTOUR_NOT_CONFIGURED": "Payout details aren't being collected yet.",
        "UNKNOWN": "Couldn't save. Please try again."
      }
    }
  },
  "dates": {
    "monthsFull": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthsShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "monthsGenitive": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "weekdaysShort": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "dayMonth": "{{month}} {{day}}",
    "dayMonthShort": "{{month}} {{day}}",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday",
    "dayMonthAtTime": "{{date}} at {{time}}"
  },
  "a11y": {
    "openMenu": "Open menu",
    "toggleTheme": "Switch theme",
    "back": "Back",
    "close": "Close",
    "menu": "Menu"
  },
  "permissions": {
    "galleryTitle": "No access",
    "galleryBody": "Allow access to the photo library in Settings."
  },
  "postDiscussion": {
    "open": "Discuss",
    "openA11y": "Open the post discussion",
    "create": "Create a discussion",
    "createHint": "A linked discussion appears in the master's chats. For a subscribers-only post it is open to subscribers only."
  },
  "repost": {
    "title": "Repost to your feed",
    "placeholder": "Add a few words of your own (optional)",
    "publish": "Publish",
    "done": "Published to your feed",
    "signIn": "Sign in to repost to your feed.",
    "action": "Repost",
    "actionA11y": "Repost to your feed",
    "kindPost": "Post",
    "kindAnnouncement": "Announcement",
    "kindEvent": "Event",
    "kindPractice": "Practice",
    "kindRecording": "Recording",
    "kindRoom": "Live session",
    "unknownAuthor": "Author",
    "openOriginal": "Open the original",
    "unavailable": "The original was deleted or is unavailable",
    "lockedSubscription": "Available in full to the master's subscribers",
    "lockedPurchase": "Available in the master's program",
    "subscribeCta": "Subscribe",
    "purchaseCta": "Open the program",
    "stateCancelled": "Cancelled",
    "stateLive": "Live now",
    "stateEnded": "Ended",
    "durationMin": "{{n}} min",
    "errNotAllowed": "This can't be reposted: a private event, Live session or practice.",
    "errNotFound": "The original wasn't found or is no longer available.",
    "errOpen": "Could not prepare the repost. Check your connection and try again.",
    "errPrivateRoom": "This Live session is private, so it cannot be reposted to the feed.",
    "errCancelledRoom": "This meeting was cancelled, so it cannot be reposted to the feed."
  },
  "rewardReactions": {
    "locked": "This reaction is a gift for a completed profile. Complete it by {{date}} and it will unlock.",
    "rewardOnly": "This reaction is a gift for completing your profile in the first month.",
    "unlocked": "Your profile is complete — three signature reactions are now yours. You'll find them among the reactions.",
    "lockedA11y": "{{label}} — unlocks with a completed profile"
  },
  "eventReport": {
    "tell": "Tell how it went",
    "tellHint": "The report will appear in your feed",
    "published": "Event report published",
    "openReport": "Open the report",
    "overline": "Event report",
    "placeholder": "Tell how it went",
    "detach": "Don't link to the event",
    "loading": "Loading the event…",
    "loadFailed": "Couldn't load the event.",
    "retry": "Try again",
    "postChip": "Event report",
    "openEvent": "Open the event this report is about",
    "blocked": {
      "deleted": "This event was deleted, so the report can't be linked to it. Remove the link and the text will go out as a regular post.",
      "not_own": "This is another master's event — you can only report on your own.",
      "online": "Reports are for offline events, and this one was online.",
      "not_ended": "The event hasn't ended yet — you can tell about it once it's over.",
      "already_reported": "A report on this event is already published; there's no need for a second one."
    }
  }
}
